<template>
  <b-card class="">
    <div class="mb-6">
      <h2 class="font-weight-bolder light-blue">
        {{ $t("market") }}
      </h2>
      <b-row>
        <b-col
            md="12"
            class="mb-5"
        >
          <Table
            :fields="fields"
            :url="'/market/invoices'"
            :show-filter="false"
            style="min-height: 30vh"
            @row-clicked="myRowClickHandler"
          >
            <template #cell(id)="data">
              <p
                  style="width: 55px"
                  class="badge badge-light-primary"
              >
                I-{{ data.item.id }}
              </p>
            </template>
            <template #cell(reference)="data">
              <b-link :to="'/market/' + data.item.id">
                {{ data.item.id }}
              </b-link>
            </template>
            <template #cell(investment_amount)="data">
                <span
                    v-if="data.item.scoring && data.item.scoring.amount_with_discount"
                    class="badge badge-secondary"
                >
                {{ amountFormat(CalculationsHelper.getInvestmentAmount(data.item), data.item.currency.name) }}
              </span>
              <span v-else-if="data.item.sum_investment_amount">
                {{ amountFormat(data.item.sum_investment_amount, data.item.currency.name)  }}
              </span>
            </template>
            <template #cell(debtor)="data">
              <span v-if="data.item.marketplace_debtor && data.item.marketplace_debtor.description && companyDescription(data.item.marketplace_debtor.description)">
                {{  companyDescription(data.item.marketplace_debtor.description) }}
              </span>
              <span
                  v-else-if="
                  data.item.marketplace_debtor &&
                  data.item.marketplace_debtor.credit_reform_one &&
                  data.item.marketplace_debtor.credit_reform_one.industry
                "
              >
                <span
                    v-if="
                    isJsonString(data.item.marketplace_debtor.credit_reform_one.industry)
                  "
                >
                  {{
                    JSON.parse(data.item.marketplace_debtor.credit_reform_one.industry)[
                      $store.state.app.language
                    ]
                  }}
                </span>
                <span v-else>
                  {{ data.item.marketplace_debtor.credit_reform_one.industry }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
            <template #cell(currency)="data">
              <span
                v-html="
                  data.item && data.item.currency && data.item.currency.code
                    ? data.item.currency.code
                    : '-'
                "
              />
            </template>
            <template #cell(seller)="data">
              <span v-if="data.item.marketplace_company && data.item.marketplace_company.description && companyDescription(data.item.marketplace_company.description)">
                {{
                  companyDescription(data.item.marketplace_company.description)
                }}
              </span>
              <span
                v-else-if="
                  data.item.marketplace_company &&
                  data.item.marketplace_company.credit_reform_one
                "
              >
                <span
                  v-if="
                    isJsonString(data.item.marketplace_company.credit_reform_one.industry)
                  "
                >
                  {{
                    JSON.parse(data.item.marketplace_company.credit_reform_one.industry)[
                      $store.state.app.language
                    ]
                  }}
                </span>
                <span v-else>
                  3333 {{ data.item.marketplace_company.credit_reform_one.industry }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
            <template #cell(net_return)="data">
              <span v-if="data.item && data.item.sum_net_return">
                {{ amountFormat(data.item.sum_net_return, data.item.currency.name)  }}
              </span>
            </template>
            <template #cell(roi_in_%)="data">
              <span
                v-if="data.item && data.item.scoring"
              >
                ~{{ CalculationsHelper.getInvestorRoiPercentage(data.item)}}
              </span>
              %
            </template>
            <template #cell(rating)="data">
              <b-badge
                v-if="
                  data.item && data.item.scoring
                "
                variant="success"
              >
                {{ data.item.scoring.rating }}
              </b-badge>
              <div v-else>
                -
              </div>
            </template>
            <template #cell(amount)="data">
              <span
                v-if="data.item && data.item.scoring.amount"
                class="badge badge-secondary"
              >
                ddd
                {{ amountFormat(data.item.scoring.amount, data.item.currency.name) }}
              </span>
              <span v-else> - </span>
            </template>
            <template #cell(due_days)="data">
              <span
                v-if="data.item && data.item.due_date"
                style="width: 60px !important"
              >
                {{ dueDaysLeft(data.item.due_date) }}
              </span>
              <span v-else> - </span>
            </template>
            <template #cell(due_date)="data">
              <span
                v-if="data.item && data.item.due_date"
                style="width: 50px !important; font-size: 12px"
              >
                {{ data.item.due_date }}
              </span>

              <span v-else> - </span>
            </template>
            <template #cell(fractions)="data">
              {{ getDate(data.item) }}
            </template>
            <template #cell(progress)="data">
              <b-progress
                variant="success"
                :value="data.item.fractions"
                max="100"
                height="14px"
              />
              <span> {{ data.item.fractions }}% </span>
            </template>
            <template #cell(action)="data">
              <b-badge
                v-if="data.item.fractions !== 100"
                style="padding: 12px"
                class="pointer"
                variant="primary"
              >{{ $t("details") }}
              </b-badge>
            </template>
          </Table>
        </b-col>
      </b-row>
    </div>
    <ApproveModal
        :text-content="modalText"
        :title="modalTitle"
    />
  </b-card>
</template>
<script>
import Table from '@/components/common/Table.vue'
import ApproveModal from '@/components/common/ApproveModal'
import i18n from '@/libs/i18n'
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat'
import CalculationsHelper from "@/helpers/calculationsHelper";

export default {
  components: { Table, ApproveModal },
  data() {
    return {
      CalculationsHelper,
      doesAnyInvoiceExist: false,
      invoices: [],
      fields: [],
      approveModalAction: null,
      modalText: '',
      modalTitle: '',
      invoice: null,
      items: [],
    }
  },
  created() {
    this.fillFieldsVar()

  },
  methods: {
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },
    isJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    fillFieldsVar() {
      this.fields = [
        {
          label: 'id',
          align: 'start',
          key: 'id',
          sortable: true,
        },
        {
          label: 'seller_industry',
          align: 'start',
          key: 'seller',
          sortable: false,
        },
        {
          label: 'debtor_industry',
          align: 'start',
          key: 'debtor',
          sortable: false,
        },
        {
          label: 'rating', align: 'rating', key: 'rating', sortable: false,
        },
        {
          label: 'currency',
          align: 'start',
          key: 'currency',
          sortable: false,
        },
        {
          label: 'investment_amount',
          align: 'start',
          key: 'investment_amount',
          tdClass: 'text-right',
          thClass: 'text-right',
        },
        {
          label: 'roi_in_%',
          align: 'start',
          key: 'roi_in_%',
          sortable: false,
        },
        {
          label: 'due_days',
          align: 'start',
          key: 'due_days',
          sortable: false,
        },
        {label: 'funding_status', key: 'progress', sortable: false},
        {
          label: 'action', align: 'start', key: 'action', sortable: false,
        },
      ]
    },
    companyDescription(company_description) {

      if (company_description == null) {
        return false
      }

      if (!this.isJsonString(company_description)) {
        return false
      }

      company_description = JSON.parse(company_description)
      if (company_description && company_description.hasOwnProperty(this.$store.state.app.language)) {
        return company_description[this.$store.state.app.language]
      }

      return false
    },
    myRowClickHandler(record, index) {
      this.$router.push(`/market/${record.id}`)
    },
    changeModalInfo(action, title, text, item) {
      this.approveModalAction = action;
      this.modalText = text;
      this.modalTitle = title;
      this.invoice = item;
    },
    callApproveModalAction() {},
    getDate(item) {
      if (item.status === 11) {
        return i18n.t("settled");
      } else {
        const currentDate = new Date();
        const yourDate = new Date(item.due_date);
        if (item.status === 11) {
          return i18n.t("settled");
        } else if (yourDate < currentDate) {
          return i18n.t("overdue");
        } else if (yourDate > currentDate) {
          return i18n.t("Open");
        }
      }
    },
  },
};
</script>
